export const getExtension = (filename: string): string => {
  const ext = filename.split('.').pop();
  if (typeof ext === 'undefined') {
    return '';
  }
  return ext;
};
